import { render, staticRenderFns } from "./D001.vue?vue&type=template&id=09e85ca7&scoped=true&"
import script from "./D001.vue?vue&type=script&lang=js&"
export * from "./D001.vue?vue&type=script&lang=js&"
import style0 from "./D001.vue?vue&type=style&index=0&id=09e85ca7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e85ca7",
  null
  
)

export default component.exports